import { firebaseDB, firebaseAuth, firebaseStorageRef } from '@/config/firebaseConfig'

export const addItem = async ({ getters }, item) => {
  const shopRef = firebaseDB().ref('stores/' + getters.shopId)
  const ref = 'products/' + getters.products.length
  item.id = getters.products.length
  return shopRef.child(ref).set(item)
}

export const addLogo = async ({ commit, getters }, f) => {
  try {
    const snapshot = await firebaseStorageRef.child(getters.shopId + '/' + f.name).putString(f.path, 'data_url')
    const url = await snapshot.ref.getDownloadURL()
    commit('ADD_URL_LOGO', url)
    const shopRef = firebaseDB().ref('storeAdmin/' + getters.shopId)
    shopRef.child('logos').set(getters.logos)
  } catch (error) {
    console.log(error)
  }
}

export const addProductImage = async ({ commit, getters }, f) => {
  try {
    const snapshot = await firebaseStorageRef.child(getters.shopId + '/' + f.name).putString(f.path, 'data_url')
    const url = await snapshot.ref.getDownloadURL()
    commit('ADD_URL_GALLERY', url)
    const shopRef = firebaseDB().ref('storeAdmin/' + getters.shopId)
    shopRef.child('productImages').set(getters.gallery)
  } catch (error) {
    console.log(error)
  }
}

export const checkStoreName = async ({ commit, getters }, shopName) => {
  try {
    const snapshot = await firebaseDB().ref(`stores/${shopName}`).once('value')
    if (snapshot.exists()) {
      console.log('extits')
      return true
    } else {
      return false
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateItem = async ({ commit, getters, dispatch }, item) => {
  const shopRef = firebaseDB().ref('stores/' + getters.shopId)
  const myItem = { ...item }
  delete myItem.key
  const ref = 'products/' + item.key
  await shopRef.child(ref).set(myItem)
  return dispatch('getProductList')
}
export const logout = async ({ commit, dispatch, getters }) => {
  commit('CLEAR_SHOP', [])
  commit('CLEAR_CUSTOMERS')
  commit('CLEAR_PRODUCTS')
  await dispatch('unbindOrders')
  return firebaseAuth().signOut()
}
